module.exports = __webpack_public_path__ + "static/media/physio5_sqr.720a4795.jpg";